import { render, staticRenderFns } from "./dataIndex.vue?vue&type=template&id=bd645756&scoped=true&"
import script from "./dataIndex.vue?vue&type=script&lang=js&"
export * from "./dataIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd645756",
  null
  
)

export default component.exports